import React from "react";
import {
  InternationalGrantingDiv,
  GrantAgreementHead,
  GrantDescription
} from "../styles";
import PropTypes from "prop-types";

class InternationalGrant extends React.Component {
  componentDidMount() {
    setTimeout(this.props.ctaEventHandler);
  }

  render() {
    return (
      <InternationalGrantingDiv data-test="InternationalGrant">
        <GrantAgreementHead>
          {this.props.internationalGrantTitle}
        </GrantAgreementHead>
        <GrantDescription dangerouslySetInnerHTML={{ __html: this.props.internationalGrantDescription }} />
      </InternationalGrantingDiv>
    )
  }
}

InternationalGrant.propTypes = {
  ctaEventHandler: PropTypes.func,
  internationalGrantDescription: PropTypes.any,
  internationalGrantTitle: PropTypes.any
}

export default InternationalGrant;
